@if (IsVisible) {
  <div>
    <div class="bar">
      <svg>
        <circle class="bg" cx="57" cy="57" r="52" />
        <circle class="meter-1" cx="57" cy="57" r="52" />
      </svg>
    </div>
  </div>
}
